module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review",
    class: {
      scene: _vm.metrics
    }
  }, [_c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.metrics),
      expression: "!metrics"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.items.summary.title))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.metrics),
      expression: "!metrics"
    }],
    staticClass: "prompt"
  }, [_vm._v(_vm._s(_vm.items.summary.text))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.metrics),
      expression: "!metrics"
    }],
    staticClass: "landing animated fadeIn"
  }, _vm._l((_vm.items.activity.scenes), function(item, index) {
    return _c('div', {
      staticClass: "step",
      on: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.step[index]),
        expression: "step[index]"
      }],
      staticClass: "selected"
    }, [_c('i', {
      staticClass: "fas fa-check"
    })]), _vm._v(" "), _c('img', {
      attrs: {
        "src": 'media/page3/' + item.image
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "holder"
    }, [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.options[_vm.choices[index]].text))])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.metrics),
      expression: "metrics"
    }],
    staticClass: "feedback animated fadeIn"
  }, [_c('button', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.metrics = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": 'media/page3/' + _vm.items.activity.scenes[_vm.id].image
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('h2', [_vm._v(_vm._s(_vm.items.activity.scenes[_vm.id].title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.items.activity.scenes[_vm.id].text))])]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, _vm._l((_vm.items.activity.scenes[_vm.id].options), function(item, index) {
    return _c('div', {
      staticClass: "fas",
      class: {
        correct: index == _vm.best[_vm.id]
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.best[_vm.id]),
        expression: "index == best[id]"
      }],
      staticClass: "best"
    }, [_c('img', {
      attrs: {
        "src": "media/page3/best.png"
      }
    })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == _vm.choices[_vm.id]),
        expression: "index == choices[id]"
      }],
      staticClass: "yours"
    }, [_c('p', [_vm._v("YOU")])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06870837"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/components/Review.vue
// module id = 123
// module chunks = 0